import React from 'react'
import { graphql } from 'gatsby'

import Seo from './../components/Layout/Seo'
import Constructor from './../components/Layout/Constructor'

const PageTemplate = ({
    pageContext: {
        layout: {
            langSlug,
            slug
        }
    },
    data: {
        contentfulPage: {
            category,
            name,
            components,
            seoImage,
            seoTitle
        }
    }
}) => {
    return (
        <>
            <Seo 
                title={seoTitle || name} 
                image={seoImage && seoImage}
            />
            <Constructor 
                lang={langSlug}
                slug={slug}
                category={category}
                data={components}
            />
        </>
    )
}

export const query = graphql`
	query($id: String!) {
		contentfulPage(id: {eq: $id}) {
            ...PageQuery
        }
	}
`

export default PageTemplate
